var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-infos",class:{'two' : !_vm.$slots.right_item}},[_c('div',{staticClass:"all-items"},[_c('div',{staticClass:"item"},[_vm._t("left_item")],2),_c('div',{staticClass:"item",class:{'no-border' : !_vm.$slots.right_item}},[_vm._t("mid_item")],2),_c('div',{staticClass:"item no-border"},[_vm._t("right_item")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }